export default __webpack_public_path__ + "static/media/3.7d03e2c1.webp";